import axios, { getData } from "lib/axios"

export const externalJobAdvertisements = async (method = "get", id = null) => {
  return axios({
    method: method,
    url: `/job_seekers/external_job_lists/${id}`,
  }).then(getData)
}
